import { MenuButton } from '@chakra-ui/react';
import { IconButton } from 'Atoms/Buttons/Buttons.tsx';
import { Checkbox } from 'Atoms/Checkbox/Checkbox.tsx';
import { BusinessUnitsSortingType } from 'containers/Assessments/pieces/Assessment.hooks.ts';
import { useUserSetting } from 'containers/Navigation/Navigation.hooks.tsx';
import { Menu } from 'Molecules/Menu/Menu.tsx';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { MoreIcon } from 'Tokens/Icons/Function.tsx';

export const CompanyStructureHeaderActions = ({
  businessUnitsSorting,
}: {
  businessUnitsSorting: BusinessUnitsSortingType;
}) => {
  const { sortAlphabetically, groupsFirst, toggleSortingAlphabetically, toggleSortingGroupsFirst } =
    businessUnitsSorting;

  const [performanceModeEnabled, setPerformanceModeEnabled, loading, updatingInfo] = useUserSetting(
    'performanceModeEnabled',
    false
  );

  useEffect(() => {
    if (updatingInfo.called && !updatingInfo.loading) {
      window.location.reload();
    }
  }, [updatingInfo.called, updatingInfo.loading]);

  return (
    <Menu
      size="md"
      menuButton={
        <MenuButton
          as={IconButton}
          aria-label="Sort reporting units"
          size="sm"
          variant="secondary"
          icon={<MoreIcon color="inherit" />}
        />
      }
      sections={[
        {
          actions: [
            {
              id: 'Reporting unit sorting alphabetically',
              title: 'Sort alphabetically',
              onClick: (e) => {
                setTimeout(() => {
                  toggleSortingAlphabetically();
                }, 100);
                e?.stopPropagation();
              },
              variant: 'ghost',
              rightElement: (
                <Checkbox
                  as="div" // rely on MenuItem's onClick to handle everything
                  isChecked={sortAlphabetically}
                />
              ),
            },
            {
              id: 'Reporting unit sorting groups on top',
              title: 'Groups on top',
              onClick: (e) => {
                setTimeout(() => {
                  toggleSortingGroupsFirst();
                }, 100);
                e?.stopPropagation();
              },
              variant: 'ghost',
              rightElement: (
                <Checkbox
                  as="div" // rely on MenuItem's onClick to handle everything
                  isChecked={groupsFirst}
                />
              ),
            },
          ],
        },
        {
          actions: [
            {
              id: 'performance-mode',
              title: 'Performance mode',
              onClick: () => {
                setPerformanceModeEnabled(!performanceModeEnabled);
              },
              variant: 'ghost',
              rightElement: (
                <Checkbox
                  as="div" // rely on MenuItem's onClick to handle everything
                  isChecked={performanceModeEnabled}
                />
              ),
            },
          ],
        },
      ]}
    />
  );
};
